export default __webpack_public_path__ + "static/media/civisLogo.e55a9838.svg";